import { InspectionActionUnavailableReason } from '../types/enums';

/**
 * Human-readable rejection per action-unavailability reason, shared by the request-estimate and
 * request-upgraded-services use cases (and any client rendering the rejection). Exhaustive over the
 * enum so a new reason fails compilation here instead of surfacing as an undefined message at runtime.
 */
export const INSPECTION_ACTION_ERRORS: Record<InspectionActionUnavailableReason, { message: string; field: string }> = {
  [InspectionActionUnavailableReason.NOT_COMPLETED]: {
    message: 'Inspection must be completed',
    field: 'status',
  },
  [InspectionActionUnavailableReason.UNSUPPORTED_COMPANY_TYPE]: {
    message: 'Only Leasing and Dealer inspections can request selected damage estimates',
    field: 'type',
  },
  [InspectionActionUnavailableReason.NO_DAMAGES]: {
    message: 'Inspection has no reported damages',
    field: 'damageIds',
  },
  [InspectionActionUnavailableReason.EST_SERVICE_ALREADY_ENABLED]: {
    message: 'Inspection already has EST service enabled',
    field: 'services',
  },
  [InspectionActionUnavailableReason.AIWH_SERVICE_ALREADY_ENABLED]: {
    message: 'Inspection already has AIwH service enabled',
    field: 'services',
  },
  [InspectionActionUnavailableReason.ESTIMATE_ALREADY_REQUESTED]: {
    message: 'An estimate request is already in progress for this inspection',
    field: 'estimateRequest',
  },
  [InspectionActionUnavailableReason.ESTIMATE_ALREADY_COMPLETED]: {
    message: 'Estimate has already been completed for this inspection',
    field: 'estimateRequest',
  },
  [InspectionActionUnavailableReason.UPGRADE_ALREADY_REQUESTED]: {
    message: 'A service upgrade is already in progress for this inspection',
    field: 'upgrade',
  },
  [InspectionActionUnavailableReason.SERVICES_ALREADY_ENABLED]: {
    message: 'Inspection already runs the requested services',
    field: 'services',
  },
  [InspectionActionUnavailableReason.NOT_UPGRADEABLE_FLOW]: {
    message: 'Inspection flow type does not support a service upgrade',
    field: 'flowType',
  },
  [InspectionActionUnavailableReason.UPGRADE_REQUIRED]: {
    message: 'Request upgraded services first — estimates become available once the services are enabled',
    field: 'services',
  },
};
